import { get } from "./api.utils";
import { FeatureFlag } from "../types/featureflag.typer";

interface FeatureflagApi {
  hentFeatureFlags: () => Promise<FeatureFlag>;
}

export const featureflagApi: FeatureflagApi = {
  hentFeatureFlags: async (): Promise<FeatureFlag> => {
    const { data } = await get<FeatureFlag>("/featureflag");
    return data;
  },
};
